import Vue from 'vue'
import App from './App.vue'
import router from './router'
// 引用全局样式
import './assets/css/global.css'
// 引用element插件
import './plugins/element.js'
import Mygv from './plugins/mygv.js'

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
Vue.prototype.global = Mygv

// 页面头部显示title标签内容
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
